import apiClient from './apiClient';

export async function fetchSettings() {
  const { data } = await apiClient.get('/settings');
  return data;
}

export async function saveSetting(key, value) {
  const { data } = await apiClient.put(`/settings/${key}`, { value });
  return data;
}
